import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Sale } from 'src/app/models/Sale';
import { ChartOptions, ChartType, ChartDataset, ChartData } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-graf-skladisce-primerjava-stolpicni',
  templateUrl: './graf-skladisce-primerjava-stolpicni.component.html',
  styleUrls: ['./graf-skladisce-primerjava-stolpicni.component.css']
})
export class GrafSkladiscePrimerjavaStolpicniComponent implements OnInit, OnChanges {
  @Input() dateList;
  @Input() dataList: Array<Sale>;
  @Input() saleFilter;
  public valList: Array<number> = [];
  public valCmpList: Array<number> = [];
  public percentList: Array<number> = [];
  public barChartOptions: ChartOptions = {
    responsive: true,

    // We use these empty structures as placeholders for dynamic theming.
    scales: { x: {}, y: {} },
    plugins: {
      //to ne prikaže številk na grafu
      datalabels: {
        display: false,
      },
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.parsed.y;
            if (value >= 1000) {
              label += value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
              label += value;
            }
            return label;
          }
        }
      }

    },
    elements: {
      point: {
        radius: 2
      }
    },
  };
  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];
  public barChartColors = [
    {
      backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)'],
    },
  ];
  public barChartData: ChartDataset[] = [
    {
      data: [],
      label: 'Lani/letos (odstotek)'
    }
  ];
  public colors: any = [];
  public reversedListDates = [];
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngOnInit();
  }

  ngOnInit() {
    console.log(this.dataList);
    this.getSumByDates();
    console.log(this.valList);
    console.log(this.valCmpList);
    this.getPercent();
    console.log(this.percentList);
    this.getDates();
    this.barChartLabels = this.reversedListDates;

    this.barChartData = [
      { data: this.percentList, label: 'Lani/letos (odstotek)' }
    ];
    this.barChartColors = [{
      backgroundColor: [],
    }];
    for (let i = 0; i < this.percentList.length; i++) {
      if (this.percentList[i] < 0) {
        this.barChartColors[0].backgroundColor.push('rgb(220,20,60)');
      } else {
        this.barChartColors[0].backgroundColor.push('rgb(152,251,152)');
      }
    }
  }

  getDates() {
    this.reversedListDates = [];
    for (let i = this.dateList.length - 1; i >= 0; i--) {
      this.reversedListDates.push(this.dateList[i]);
    }
  }

  roundingToolNoDecimal(num) {
    return Math.round(num);
  }

  getSumByDates() {
    for (let i = 0; i < this.dateList.length; i++) {
      let sumVal = 0;
      let sumValCmp = 0;
      for (let j = 0; j < this.dataList.length; j++) {
        if (this.dateList[i] === this.dataList[j].date) {
          if (this.saleFilter === 'SALEVALUE') {
            sumVal += this.dataList[j].saleVal;
            sumValCmp += this.dataList[j].saleValCmp;
          } else if (this.saleFilter === 'MARGINPERCENT') {
            sumVal += this.dataList[j].marginPrc;
            sumValCmp += this.dataList[j].marginPrcCmp;
          } else if (this.saleFilter === 'SALEVALUEWT') {
            sumVal += this.dataList[j].saleValWT;
            sumValCmp += this.dataList[j].saleValWTCmp;
          } else if (this.saleFilter === 'QUANTITY') {
            sumVal += this.dataList[j].quantity;
            sumValCmp += this.dataList[j].quantityCmp;
          } else if (this.saleFilter === 'DOCUMENTCOUNT') {
            sumVal += this.dataList[j].docCount;
            sumValCmp += this.dataList[j].docCountCmp;
          } else if (this.saleFilter === 'ITEMCOUNT') {
            sumVal += this.dataList[j].itemCount;
            sumValCmp += this.dataList[j].itemCountCmp;
          }
        }
      }
      this.valList.push(this.roundingToolNoDecimal(sumVal));
      this.valCmpList.push(this.roundingToolNoDecimal(sumValCmp));
    }
  }

  getPercent() {
    for (let i = this.dataList.length - 1; i >= 0; i--) {
      if (this.dataList[i]) {
        if (this.dataList[i].saleValCmp != 0) {
          this.percentList.push(this.roundingToolNoDecimal((this.dataList[i].saleVal / this.dataList[i].saleValCmp) * 100) - 100);
        } else {
          this.percentList.push(0);
        }
      }
    }
  }

}
